import React from "react";
import Head from "next/head";
import { Hooks } from "@xt/xtbase";
const { useIntl } = Hooks;

import Alternate from "./Alternate";
import Social from "./Social";

const DEFAULT_SITE_TITLES = {
  en: "Spikex | AI-Driven CopyTrading & Crypto Trading Platform",
  "zh-CN": "Spikex | AI 驱动跟单 & 加密货币交易平台",
  "zh-HK": "Spikex | AI 驅動跟單 & 加密貨幣交易平台",
  pt: "Spikex | Copy Trading com IA & Plataforma de Negociação de Criptomoedas",
  ar: "Spikex | نسخ التداول بالذكاء الاصطناعي & منصة تداول العملات المشفرة",
  vi: "Spikex | Copy Trading bằng AI & Nền tảng Giao dịch Crypto",
};

/** CMS 未返回 describe 时兜底（与 ssr-web-index Seo 一致） */
const DEFAULT_DESCRIPTION = {
  en: "Spikex is an AI-Driven CopyTrading & Crypto Trading Platform for crypto, forex, and commodities—offering Futures, smart tools, and secure global execution.",
  "zh-CN":
    "Spikex 是 AI 驱动跟单 & 加密货币交易平台，面向加密货币、外汇与大宗商品，支持期货等多元产品，安全、全球化服务。",
  "zh-HK":
    "Spikex 是 AI 驅動跟單 & 加密貨幣交易平台，面向加密貨幣、外匯與大宗商品，支援期貨等多元產品，安全、全球化服務。",
  pt: "A Spikex é uma plataforma de Copy Trading com IA e negociação de criptomoedas para crypto, forex e commodities — com Futuros, ferramentas inteligentes e execução global segura.",
  ar: "سبيكس هي منصة نسخ التداول بالذكاء الاصطناعي وتداول العملات المشفرة للعملات المشفرة والفوركس والسلع — مع العقود الآجلة والأدوات الذكية وتنفيذ آمن على مستوى العالم.",
  vi: "Spikex là nền tảng Copy Trading bằng AI & giao dịch tiền mã hóa cho crypto, forex và hàng hóa — với Futures, công cụ thông minh và thực thi an toàn trên toàn cầu.",
};

const DEFAULT_KEYWORDS = [
  "Spikex",
  "AI-Driven CopyTrading",
  "Crypto Trading Platform",
  "Copy Trading",
];

function normalizeTdk(raw = {}) {
  const tdk = raw?.data && typeof raw.data === "object" ? raw.data : raw;
  let keyword = tdk.keyword;
  if (typeof keyword === "string") {
    keyword = keyword.split(",").map((s) => s.trim()).filter(Boolean);
  } else if (!Array.isArray(keyword)) {
    keyword = DEFAULT_KEYWORDS;
  }
  return { ...tdk, keyword };
}

export default function SEO({ tdk: tdkProp = {}, resolvedUrl, locale = "en", basePath = "accounts" }) {
  const intl = useIntl();
  const tdk = normalizeTdk(tdkProp);

  const rawTitle = typeof tdk.title === "string" ? tdk.title.trim() : "";
  const title = !rawTitle || rawTitle === "Spikex"
    ? (DEFAULT_SITE_TITLES[locale] || DEFAULT_SITE_TITLES.en)
    : rawTitle;

  const rawDescribe = typeof tdk.describe === "string" ? tdk.describe.trim() : "";
  let description = rawDescribe || DEFAULT_DESCRIPTION[locale] || DEFAULT_DESCRIPTION.en;
  if (!description) {
    try {
      description = intl.formatMessage({ id: "app.description" });
    } catch {
      description = DEFAULT_DESCRIPTION.en;
    }
  }

  const keywords = tdk.keyword;

  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords.join(",")} />
      <meta
        name="viewport"
        content="minimal-ui,width=device-width,initial-scale=1,maximum-scale=1,user-scalable=no,viewport-fit=cover"
      />
      <Alternate resolvedUrl={resolvedUrl} locale={locale} basePath={basePath} />
      <Social
        title={title}
        description={description}
        resolvedUrl={resolvedUrl}
        locale={locale}
        basePath={basePath}
      />
    </Head>
  );
}
